<div class="padding" id="div_padding_54452585"></div>
<p-multiSelect
  id="multiSelect"
  [placeholder]="placeholder"
  [options]="filter.values"
  [(ngModel)]="selected"
  optionLabel="name"
  [styleClass]="allStyleClass"
  [showHeader]="false"
  (onChange)="this.emitContents($event)"
></p-multiSelect>
